module.exports = __webpack_public_path__ + "img/icon-logout.d45f485d.png";